import {Injectable} from '@angular/core';
import * as CryptoJS from 'crypto-js';
import {environment} from '@drl/env/environment';
@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  // Replace 'your-secret-key' and 'your-static-iv' with your actual values
  private key: string = environment.AES_KEY;
  private iv: string = environment.IV;

  encryptData(data: string): string {
    // Convert key and IV to WordArray
    const keyHex = CryptoJS.enc.Utf8.parse(this.key);
    const ivHex = CryptoJS.enc.Utf8.parse(this.iv);

    // Encrypt using AES-CBC mode
    const encrypted = CryptoJS.AES.encrypt(data, keyHex, {iv: ivHex});

    // Return encrypted data as Base64-encoded string
    const encryptedStn = encrypted.toString();

    return encryptedStn;
  }
}


